// import React, { useContext, useEffect, useState } from 'react';
// import { useTranslation } from 'react-i18next';
// import { Link, useNavigate } from 'react-router-dom';
// import { AppSettings } from '@config/app-settings';
// import ReportsBuilder2 from './ReportsBuilder2/ReportsBuilder2';
// import { useAppSelector } from '@store/hooks';
// import Loading from '@components/Shared/Loader/Loading';
// import { Card } from '@components/card/card';

// interface Props {
//   ReportsList: any[];
//   loading?: boolean;
//   reportType?: 'custom-only' | 'both';
// }

// // ✅ مكون بطاقة التقرير
// const ReportCard = ({ report, isActive, onClick, language }: any) => {
//   const { t } = useTranslation();

//   // console.log(report);

//   const reportName = language === 'en' ? report?.name : report?.name2
//   const reportModule = language === 'en' ? report?.moduleName : report?.moduleName2 || report?.moduleName;
//   const reportIcon = report?.icon || (report.type === 'static' ? 'bi-file-earmark-text' : 'bi-gear');

//   return (
//     <div
//       className={`${
//         isActive ? 'border-theme bg-theme bg-opacity-15' : ''
//       } hover-shadow-sm transition-all cursor-pointer mb-2`}
//       onClick={onClick}
//     >
//       <Card>
//         <div className='card-body p-3'>
//           <div className='d-flex align-items-center'>
//             <i
//               className={`  ${reportIcon} ${isActive ? 'text-theme' : 'text-theme'}`}
//               style={{ fontSize: '1.4rem' }}
//             ></i>
//             <div className='flex-grow-1' style={{ minWidth: 0 }}>
//               <div className='d-flex justify-content-between align-items-start'>
//                 <h6 className='mb-0 fw-semibold text-truncate' style={{ maxWidth: '320px' }}>
//                   {reportName}
//                 </h6>
//                 {report.type === 'static' && (
//                   <span className='badge bg-success bg-opacity-10 text-success small'>
//                     <i className='bi bi-check-circle me-1'></i>
//                     {t('Standard')}
//                   </span>
//                 )}

//               </div>
//               {reportModule && (
//                 <span className='badge bg-warning bg-opacity-10 text-warning small'>
//                     <i className='bi bi-gear me-1'></i>
//                     {t('Custom')}
//                   </span>
//               )}
//               {report.description && (
//                 <div className='small text-muted mt-1'>
//                   {language === 'en' ? report.description : report.description2 || report.description}
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       </Card>
//     </div>
//   );
// };

// const Index2: React.FC<Props> = ({ ReportsList, reportType = 'custom-only' }) => {
//   const { t, i18n } = useTranslation();
//   const navigate = useNavigate();
//   const [report, setReport] = useState<any>(null);
//   const [search, setSearch] = useState('');
//   const { loading } = useAppSelector(state => state.Reports);
//   const [activeTab, setActiveTab] = useState<'static' | 'custom'>('custom');

//   const context = useContext(AppSettings);

//   useEffect(() => {
//     context.setAppContentFullHeight(true);
//     context.setAppContentClass('p-0');
//     context.setAppSidebarCollapsed(true);

//     return function cleanUp() {
//       context.setAppContentFullHeight(false);
//       context.setAppContentClass('');
//       context.setAppSidebarCollapsed(false);
//     };
//   }, [context]);

//   const filteredReports = ReportsList?.filter(
//     item =>
//       item.name.toLowerCase().includes(search.toLowerCase()) ||
//       item.name2?.toLowerCase().includes(search.toLowerCase()) ||
//       item.moduleName?.toLowerCase().includes(search.toLowerCase()) ||
//       item.moduleName2?.toLowerCase().includes(search.toLowerCase())
//   );

//   const staticReports = filteredReports?.filter(item => item.type === 'static');
//   const customReports = filteredReports?.filter(item => item.type === 'custom');

//   const showTabs = reportType === 'both';
//   const reportsToShow = showTabs
//     ? activeTab === 'static'
//       ? staticReports
//       : customReports
//     : reportType === 'custom-only'
//     ? customReports
//     : staticReports;

//   const totalReports = (staticReports?.length || 0) + (customReports?.length || 0);

//   return (
//     <div className='container-fluid h-100 px-4 py-3'>
//       <div className='row g-3 h-100'>
//         {/* ✅ الشريط الجانبي */}
//         <div className='col-lg-4 col-xl-3'>
//           <div className='card border-0 shadow-sm h-100'>
//             <div className='card-header bg-theme bg-opacity-10 border-bottom'>
//               <div className='d-flex align-items-center justify-content-between'>
//                 <h5 className='mb-0'>
//                   <i className='bi bi-file-earmark-text me-2'></i>
//                   {t('Reports')}
//                 </h5>
//                 <div className='badge bg-theme bg-opacity-25 text-theme'>
//                   {t('ReportsCountLabel', { count: totalReports || 0 })}
//                 </div>
//               </div>
//             </div>

//             <div className='card-body d-flex flex-column p-0'>
//               {/* ✅ قسم التحكم والبحث */}
//               <div className='p-3 border-bottom'>
//                 <div className='d-flex gap-2 mb-3'>
//                   <button
//                     className='btn btn-outline-secondary btn-sm d-flex align-items-center'
//                     onClick={() => navigate(-1)}
//                   >
//                     <i className='bi bi-arrow-left me-1'></i>
//                     {t('Back')}
//                   </button>

//                   {showTabs && (
//                     <div className='btn-group btn-group-sm flex-grow-1' role='group'>
//                       <button
//                         className={`btn ${activeTab === 'static' ? 'btn-theme' : 'btn-outline-secondary'}`}
//                         onClick={() => {
//                           setActiveTab('static');
//                           setReport(null);
//                         }}
//                       >
//                         <i className='bi bi-check-circle me-1'></i>
//                         {t('Standard')}
//                         <span className='badge bg-secondary bg-opacity-25 text-secondary ms-1'>
//                           {staticReports?.length || 0}
//                         </span>
//                       </button>
//                       <button
//                         className={`btn ${activeTab === 'custom' ? 'btn-theme' : 'btn-outline-secondary'}`}
//                         onClick={() => {
//                           setActiveTab('custom');
//                           setReport(null);
//                         }}
//                       >
//                         <i className='bi bi-gear me-1'></i>
//                         {t('Custom')}
//                         <span className='badge bg-secondary bg-opacity-25 text-secondary ms-1'>
//                           {customReports?.length || 0}
//                         </span>
//                       </button>
//                     </div>
//                   )}
//                 </div>

//                 {/* ✅ شريط البحث */}
//                 <div className='input-group input-group-sm shadow-sm'>
//                   <span className='input-group-text'>
//                     <i className='bi bi-search text-muted'></i>
//                   </span>
//                   <input
//                     type='text'
//                     className='form-control'
//                     placeholder={t('SearchReportsPlaceholder')}
//                     value={search}
//                     onChange={e => setSearch(e.target.value)}
//                     style={{ borderRight: 0 }}
//                   />
//                   {search && (
//                     <button
//                       className='btn btn-outline-secondary'
//                       type='button'
//                       onClick={() => setSearch('')}
//                       title={t('ClearSearch')}
//                     >
//                       <i className='bi bi-x'></i>
//                     </button>
//                   )}
//                 </div>
//               </div>

//               {/* ✅ قائمة التقارير */}
//               <div className='flex-grow-1' style={{ overflowY: 'auto', maxHeight: 'calc(100vh - 280px)' }}>
//                 <Loading loading={loading} Type='Dots'>
//                   {reportsToShow?.length > 0 ? (
//                     <div className={'p-3'}>
//                       {reportsToShow.map((item, index) => (
//                         <div key={index} className={''}>
//                           <ReportCard
//                             report={item}
//                             isActive={item.id === report?.id}
//                             onClick={() => setReport(item)}
//                             language={i18n.language}
//                           />
//                         </div>
//                       ))}
//                     </div>
//                   ) : (
//                     <div className='text-center py-5'>
//                       <div className='bg-light bg-opacity-25 rounded-circle p-4 d-inline-block mb-3'>
//                         <i className='bi bi-file-earmark-excel display-5 text-muted'></i>
//                       </div>
//                       <h5 className='text-muted'>{t('NoReportsFound')}</h5>
//                       <p className='text-muted small mb-0'>
//                         {search ? t('TryDifferentSearch') : t('NoReportsAvailable')}
//                       </p>
//                       {search && (
//                         <button className='btn btn-outline-secondary btn-sm mt-3' onClick={() => setSearch('')}>
//                           <i className='bi bi-arrow-counterclockwise me-1'></i>
//                           {t('ShowAllReports')}
//                         </button>
//                       )}
//                     </div>
//                   )}
//                 </Loading>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* ✅ قسم المعاينة */}
//         <div className='col-lg-8 col-xl-9'>
//           <div className='card border-0 shadow-sm h-100'>
//             {report ? (
//               <>
//                 <div className='card-header bg-theme bg-opacity-10 border-bottom'>
//                   <div className='d-flex align-items-center justify-content-between'>
//                     <div className='d-flex align-items-center'>
//                       <div className='bg-theme bg-opacity-10 rounded-circle p-2 me-3'>
//                         <i
//                           className={`bi ${report?.icon || 'bi-file-earmark-text'} text-theme`}
//                           style={{ fontSize: '1.5rem' }}
//                         ></i>
//                       </div>
//                       <div>
//                         <h4 className='mb-0 fw-bold'>
//                           {i18n.language === 'en' ? report?.name : report?.name2 || report?.name}
//                         </h4>
//                         <div className='small text-muted'>
//                           <i className='bi bi-folder me-1'></i>
//                           {i18n.language === 'en' ? report?.moduleName : report?.moduleName2 || report?.moduleName}
//                           {report.type === 'static' && (
//                             <span className='badge bg-success bg-opacity-10 text-success ms-2'>
//                               <i className='bi bi-check-circle me-1'></i>
//                               {t('StandardReport')}
//                             </span>
//                           )}
//                           {report.type === 'custom' && (
//                             <span className='badge bg-warning bg-opacity-10 text-warning ms-2'>
//                               <i className='bi bi-gear me-1'></i>
//                               {t('CustomReport')}
//                             </span>
//                           )}
//                         </div>
//                       </div>
//                     </div>
//                     <div className='btn-group' role='group'>
//                       <button
//                         className='btn btn-outline-secondary btn-sm'
//                         onClick={() => setReport(null)}
//                         title={t('ClosePreview')}
//                       >
//                         <i className='bi bi-x-lg'></i>
//                       </button>
//                     </div>
//                   </div>
//                 </div>

//                 <div className='card-body p-0' style={{ overflowY: 'auto', height: 'calc(100vh - 180px)' }}>
//                   <div className='p-1'>
//                     {report.description && (
//                       <div className='alert alert-info mb-3'>
//                         <div className='d-flex align-items-center'>
//                           <i className='bi bi-info-circle me-2'></i>
//                           <div className='small'>
//                             {i18n.language === 'en' ? report.description : report.description2 || report.description}
//                           </div>
//                         </div>
//                       </div>
//                     )}

//                     <div className='py-3'>
//                       {report.type === 'static' && report.component ? (
//                         <div className='report-preview'>{report.component}</div>
//                       ) : (
//                         <div className='report-builder'>
//                           <ReportsBuilder2 ReportId={report.id} />
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 </div>
//               </>
//             ) : (
//               <div className='card-body d-flex flex-column align-items-center justify-content-center text-center py-5'>
//                 <div className='bg-theme-light bg-opacity-10 rounded-circle p-5 mb-4'>
//                   <i className='bi bi-file-earmark-text display-1 text-theme opacity-50'></i>
//                 </div>
//                 <h3 className='mb-3'>{t('WelcomeReportManagerTitle')}</h3>
//                 <p className='text-muted mb-4' style={{ maxWidth: '500px' }}>
//                   {t('WelcomeReportManagerDescription')}
//                 </p>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// // export default Index2;

// import React, { useContext, useEffect, useMemo, useState } from 'react';
// import { useTranslation } from 'react-i18next';
// import { useNavigate } from 'react-router-dom';
// import { AppSettings } from '@config/app-settings';
// import ReportsBuilder2 from './ReportsBuilder2/ReportsBuilder2';
// import { useAppSelector } from '@store/hooks';
// import Loading from '@components/Shared/Loader/Loading';

// // react-bootstrap
// import Nav from 'react-bootstrap/Nav';
// import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
// import Tooltip from 'react-bootstrap/Tooltip';

// import { useRef } from 'react';
// import PopoverCustom from '@components/Shared/Popover/PopoverCustom';

// interface Props {
//   ReportsList: any[];
//   loading?: boolean;
//   reportType?: 'custom-only' | 'both';
// }

// type ListTabKey = 'static' | 'custom';

// const Index2: React.FC<Props> = ({ ReportsList, reportType = 'custom-only' }) => {
//   const { t, i18n } = useTranslation();
//   const navigate = useNavigate();
//   const context = useContext(AppSettings);

//   const { loading } = useAppSelector(state => state.Reports);

//   const [search, setSearch] = useState('');
//   // const [activeTab, setActiveTab] = useState<ListTabKey>('custom');
//   const [activeTab, setActiveTab] = useState<ListTabKey>('static');
//   const [report, setReport] = useState<any>(null);

//   // ✅ وضعين للـ Sidebar: (أيقونات فقط) / (أيقونات + اسم)
//   const [sidebarExpanded, setSidebarExpanded] = useState<boolean>(true);

//   useEffect(() => {
//     context.setAppContentFullHeight(true);
//     context.setAppContentClass('p-0');
//     context.setAppSidebarCollapsed(true);
//     // context.setAppHeaderNone(true);

//     return function cleanUp() {
//       context.setAppContentFullHeight(false);
//       context.setAppContentClass('');
//       context.setAppSidebarCollapsed(false);
//       // context.setAppHeaderNone(false);
//     };
//   }, [context]);

//   const tooltipRootRef = useRef<HTMLElement | null>(null);

//   useEffect(() => {
//     let el = document.getElementById('ntx-tooltip-root') as HTMLElement | null;

//     if (!el) {
//       el = document.createElement('div');
//       el.id = 'ntx-tooltip-root';
//       Object.assign(el.style, {
//         position: 'fixed',
//         inset: '0',
//         overflow: 'hidden',
//         zIndex: '3000',
//         pointerEvents: 'none' // لا يعطّل hover على الأيقونات
//       });
//       document.body.appendChild(el);
//     }

//     tooltipRootRef.current = el;
//   }, []);

//   const filteredReports = useMemo(() => {
//     const q = search.trim().toLowerCase();
//     if (!q) return ReportsList || [];

//     return (ReportsList || []).filter((item: any) => {
//       return (
//         item?.name?.toLowerCase?.().includes(q) ||
//         item?.name2?.toLowerCase?.().includes(q) ||
//         item?.moduleName?.toLowerCase?.().includes(q) ||
//         item?.moduleName2?.toLowerCase?.().includes(q)
//       );
//     });
//   }, [ReportsList, search]);

//   const staticReports = useMemo(() => filteredReports.filter((x: any) => x.type === 'static'), [filteredReports]);
//   const customReports = useMemo(() => filteredReports.filter((x: any) => x.type === 'custom'), [filteredReports]);
//   const totalReports = (staticReports?.length || 0) + (customReports?.length || 0);

//   const showTabs = reportType === 'both';

//   const reportsToShow = useMemo(() => {
//     if (!showTabs) {
//       return reportType === 'custom-only' ? customReports : staticReports;
//     }

//     if (activeTab === 'static') return staticReports;
//     return customReports;
//   }, [activeTab, customReports, reportType, showTabs, staticReports]);

//   const tabs = useMemo(() => {
//     if (!showTabs) return [];
//     return [
//       { key: 'static' as const, label: t('Standard'), count: staticReports.length || 0, icon: 'bi bi-check-circle' },
//       { key: 'custom' as const, label: t('Custom'), count: customReports.length || 0, icon: 'bi bi-gear' }
//     ];
//   }, [customReports.length, showTabs, staticReports.length, t]);

//   // ===== Sidebar: Reports (Collapsed/Expanded) =====
//   const renderReportNavItem = (r: any) => {
//     const reportName = i18n.language === 'en' ? r?.name : r?.name2 || r?.name;
//     const kindLabel = r?.type === 'static' ? t('Standard') : t('Custom');

//     // عندك icon جاهز غالباً (bi ... أو fas ...)
//     const icon = r?.icon || (r?.type === 'static' ? 'bi bi-file-earmark-text' : 'bi bi-gear');
//     const isActive = report?.id === r.id;

//     // ✅ Expanded: show name next to icon
//     if (sidebarExpanded) {
//       return (
//         <Nav.Item key={r.id} className='mb-1 w-100 px-2'>
//           <Nav.Link
//             active={isActive}
//             onClick={() => setReport(r)}
//             className='d-flex align-items-center gap-2 rounded w-100 text-body'
//             style={{
//               minHeight: '44px',
//               transition: 'all 0.2s ease',
//               justifyContent: 'flex-start',
//               padding: '10px 10px'
//             }}
//           >
//             <span
//               className='d-flex align-items-center justify-content-center rounded'
//               style={{
//                 width: 28,
//                 height: 28,
//                 flex: '0 0 auto'
//               }}
//             >
//               <i className={`${icon} ${isActive ? 'text-white' : 'text-theme'}`} style={{ fontSize: '1.15rem' }} />
//             </span>

//             <span className='text-truncate fw-semibold' style={{ fontSize: '0.9rem', minWidth: 0, flex: '1 1 auto' }}>
//               {reportName}
//             </span>

//             <span className='ms-auto flex-shrink-0'>
//               {r?.type === 'static' ? (
//                 <span className='badge bg-theme bg-opacity-10 text-theme'>
//                   <i className='bi bi-check-circle me-1' />
//                   {t('Standard')}
//                 </span>
//               ) : (
//                 <span className='badge bg-warning bg-opacity-10 text-warning'>
//                   <i className='bi bi-gear me-1' />
//                   {t('Custom')}
//                 </span>
//               )}
//             </span>
//           </Nav.Link>
//         </Nav.Item>
//       );
//     }
//     const isRtl = (document?.documentElement?.dir || i18n.dir?.()) === 'rtl';

//     // ✅ Collapsed: icon only with tooltip
//     return (
//       <PopoverCustom
//         placement={isRtl ? 'left' : 'right'}
//         // Header={reportName}
//         Body={<div className='fw-bold'>{reportName}</div>}
//         trigger={['hover', 'focus']}
//       >
//         <Nav.Item className='mb-2'>
//           <Nav.Link
//             active={isActive}
//             onClick={() => setReport(r)}
//             className='d-flex align-items-center justify-content-center p-2 rounded'
//             style={{ width: '44px', height: '44px', transition: 'all 0.2s ease' }}
//           >
//             <i className={`${icon} ${isActive ? 'text-white' : 'text-theme'}`} style={{ fontSize: '1.25rem' }} />
//           </Nav.Link>
//         </Nav.Item>
//       </PopoverCustom>
//     );
//   };

//   const reportTitle = report ? (i18n.language === 'en' ? report?.name : report?.name2 || report?.name) : '';
//   const reportDesc =
//     report && (i18n.language === 'en' ? report?.description : report?.description2 || report?.description);

//   return (
//     <>
//       <div className='container-fluid p-0' style={{ height: '100%' }}>
//         <div className='card border-0 shadow-sm h-100'>
//           {/* Header */}
//           <div className='card-header bg-theme bg-opacity-10 border-bottom'>
//             <div className='d-flex flex-wrap align-items-center justify-content-between gap-2'>
//               <div className='d-flex align-items-center gap-2'>
//                 <h5 className='mb-0 me-4'>
//                   <i className='bi bi-file-earmark-text me-2' />
//                   {t('Reports')}
//                 </h5>

//                 {/* <span className='badge bg-theme bg-opacity-25 text-theme me-3'>
//                   {t('ReportsCountLabel', { count: totalReports || 0 })}
//                 </span> */}

//                 {showTabs &&
//                   tabs.map(m => (
//                     <button
//                       key={m.key}
//                       className={`btn ${activeTab === m.key ? 'btn-theme' : 'btn-outline-theme'}`}
//                       onClick={() => {
//                         setActiveTab(m.key);
//                         setReport(null);
//                       }}
//                     >
//                       <i className={`${m.icon} me-1`} />
//                       {m.label}
//                     </button>
//                   ))}
//               </div>

//               <div className='d-flex align-items-center gap-2'>
//                 {/* ✅ Toggle Sidebar Mode */}
//                 {/* <button
//                   className='btn btn-outline-secondary btn-sm'
//                   onClick={() => setSidebarExpanded(v => !v)}
//                   title={sidebarExpanded ? t('Collapse') : t('Expand')}
//                 >
//                   <i className={`bi ${sidebarExpanded ? 'bi-layout-sidebar-inset' : 'bi-layout-sidebar'}`} />
//                 </button> */}

//                 {/* <div className='input-group   shadow-sm' style={{ minWidth: 280 }}>
//                   <span className='input-group-text'>
//                     <i className='bi bi-search text-muted' />
//                   </span>
//                   <input
//                     type='text'
//                     className='form-control'
//                     placeholder={t('SearchReportsPlaceholder')}
//                     value={search}
//                     onChange={e => setSearch(e.target.value)}
//                   />
//                   {search && (
//                     <button
//                       className='btn btn-outline-secondary'
//                       type='button'
//                       onClick={() => setSearch('')}
//                       title={t('ClearSearch')}
//                     >
//                       <i className='bi bi-x' />
//                     </button>
//                   )}
//                 </div>

//                 {report && (
//                   <button
//                     className='btn btn-outline-secondary btn-sm'
//                     onClick={() => setReport(null)}
//                     title={t('ClosePreview')}
//                   >
//                     <i className='bi bi-x-lg' />
//                   </button>
//                 )} */}
//                 <button className='btn btn-outline-secondary ' onClick={() => navigate(-1)}>
//                   {t('Back')}
//                 </button>
//               </div>
//             </div>
//           </div>

//           <Loading loading={loading}>
//             {/* Body */}
//             <div className='card-body p-0 d-flex h-100' style={{ overflow: 'hidden' }}>
//               {/* ✅ Sidebar (Collapsed/Expanded) */}
//               <div
//                 className='d-none d-md-flex flex-column flex-shrink-0 border-end bg-secondary bg-opacity-10 shadow-sm'
//                 style={{
//                   width: sidebarExpanded ? '320px' : '70px',
//                   transition: 'width 0.2s ease',
//                   overflow: 'hidden'
//                 }}
//               >
//                 {/* Small top area inside sidebar (optional) */}
//                 <div className='d-flex align-items-center justify-content-between px-2 py-2 border-bottom bg-theme bg-opacity-10'>
//                   <div className='d-flex align-items-center gap-2' style={{ minWidth: 0 }}>
//                     {/* <i className='bi bi-list text-theme' /> */}
//                     {sidebarExpanded && <span className='fw-semibold text-theme text-truncate'>{t('Reports')}</span>}
//                   </div>

//                   <button
//                     className='btn btn-sm btn-outline-theme'
//                     onClick={() => setSidebarExpanded(v => !v)}
//                     title={sidebarExpanded ? t('Collapse') : t('Expand')}
//                     style={{ width: 34, height: 34 }}
//                   >
//                     <i className={`bi ${sidebarExpanded ? 'bi-chevron-bar-right' : 'bi-chevron-bar-left'}`} />
//                   </button>
//                 </div>

//                 <div className='flex-grow-1' style={{ overflowY: 'auto' }}>
//                   <Nav
//                     variant='pills'
//                     className={`py-2 ${sidebarExpanded ? 'd-flex flex-column align-items-stretch' : 'd-flex flex-column align-items-center'}`}
//                   >
//                     {reportsToShow?.length > 0 ? (
//                       reportsToShow.map(renderReportNavItem)
//                     ) : (
//                       <OverlayTrigger
//                         placement='right'
//                         overlay={<Tooltip id='tooltip-empty'>{t('NoReportsFound')}</Tooltip>}
//                       >
//                         <div
//                           className='mt-3 d-flex align-items-center justify-content-center'
//                           style={{ width: sidebarExpanded ? '100%' : 60 }}
//                         >
//                           <i className='bi bi-file-earmark-excel text-muted' style={{ fontSize: '1.25rem' }} />
//                         </div>
//                       </OverlayTrigger>
//                     )}
//                   </Nav>
//                 </div>
//               </div>

//               {/* ✅ Main Content */}
//               <div className='flex-grow-1 h-100' style={{ overflow: 'auto' }}>
//                 {!report ? (
//                   <div className='h-100 d-flex flex-column align-items-center justify-content-center text-center p-4'>
//                     <div className='bg-theme-light bg-opacity-10 rounded-circle p-5 mb-4'>
//                       <i className='bi bi-file-earmark-text display-1 text-theme opacity-50' />
//                     </div>
//                     <h3 className='mb-3'>{t('WelcomeReportManagerTitle')}</h3>
//                     <p className='text-muted mb-0' style={{ maxWidth: 520 }}>
//                       {t('WelcomeReportManagerDescription')}
//                     </p>
//                   </div>
//                 ) : (
//                   <div className='h-100 d-flex flex-column'>
//                     <div className='border-bottom bg-body p-2'>
//                       <div className='d-flex align-items-center justify-content-between gap-2'>
//                         <div className='d-flex align-items-center' style={{ minWidth: 0 }}>
//                           <div className='bg-theme bg-opacity-10 rounded-2 p-2 me-3'>
//                             <i
//                               className={`${report?.icon || 'bi bi-file-earmark-text'} text-theme`}
//                               style={{ fontSize: '1.5rem' }}
//                             />
//                           </div>

//                           <div style={{ minWidth: 0 }}>
//                             <h6 className='mb-0 fw-bold text-truncate' style={{ maxWidth: 700 }}>
//                               {reportTitle}
//                             </h6>

//                             <div className='small text-muted text-truncate' style={{ maxWidth: 700 }}>
//                               {report?.type === 'static' ? (
//                                 <span className='badge bg-theme bg-opacity-10 text-theme ms-2'>
//                                   <i className='bi bi-check-circle me-1' />
//                                   {t('StandardReport')}
//                                 </span>
//                               ) : (
//                                 <span className='badge bg-warning bg-opacity-10 text-warning ms-2'>
//                                   <i className='bi bi-gear me-1' />
//                                   {t('CustomReport')}
//                                 </span>
//                               )}
//                             </div>
//                           </div>
//                         </div>
//                       </div>

//                       {!!reportDesc && (
//                         <div className='alert alert-info mt-3 mb-0'>
//                           <div className='d-flex align-items-center'>
//                             <i className='bi bi-info-circle me-2' />
//                             <div className='small'>{reportDesc}</div>
//                           </div>
//                         </div>
//                       )}
//                     </div>

//                     <div className='flex-grow-1' style={{ overflowY: 'auto' }}>
//                       <div className='p-2'>
//                         {report.type === 'static' && report.component ? (
//                           <div className='report-preview'>{report.component}</div>
//                         ) : (
//                           <div className='report-builder'>
//                             <ReportsBuilder2 ReportId={report.id} />
//                           </div>
//                         )}
//                       </div>
//                     </div>
//                   </div>
//                 )}
//               </div>
//             </div>
//           </Loading>
//         </div>
//       </div>

//       <style>{`
//         .nav-pills .nav-link.active {
//           background-color: var(--bs-theme);
//           transform: scale(1.02);
//         }
//         .nav-pills .nav-link:hover:not(.active) {
//           background-color: var(--bs-secondary-bg);
//           transform: scale(1.01);
//         }

//       `}</style>
//     </>
//   );
// };

// export default Index2;

import React, { useContext, useEffect, useMemo, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { AppSettings } from '@config/app-settings';
import ReportsBuilder2 from './ReportsBuilder2/ReportsBuilder2';
import { useAppSelector } from '@store/hooks';
import Loading from '@components/Shared/Loader/Loading';

// react-bootstrap
import Nav from 'react-bootstrap/Nav';
// import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
// import Tooltip from 'react-bootstrap/Tooltip';
import PopoverCustom from '@components/Shared/Popover/PopoverCustom';

interface Props {
  ReportsList: any[];
  loading?: boolean;
  reportType?: 'custom-only' | 'both';
}

type ListTabKey = 'static' | 'custom';

const Index2: React.FC<Props> = ({ ReportsList, reportType = 'custom-only' }) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const context = useContext(AppSettings);

  const { loading } = useAppSelector(state => state.Reports);

  const [search, setSearch] = useState('');
  const [activeTab, setActiveTab] = useState<ListTabKey>('static');
  const [report, setReport] = useState<any>(null);

  // التحكم في السايدبار للشاشات الكبيرة والجوال
  const [sidebarExpanded, setSidebarExpanded] = useState<boolean>(true);
  const [showMobileSidebar, setShowMobileSidebar] = useState<boolean>(false);

  useEffect(() => {
    context.setAppContentFullHeight(true);
    context.setAppContentClass('p-0');
    context.setAppSidebarCollapsed(true);

    return function cleanUp() {
      context.setAppContentFullHeight(false);
      context.setAppContentClass('');
      context.setAppSidebarCollapsed(false);
    };
  }, [context]);

  const tooltipRootRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    let el = document.getElementById('ntx-tooltip-root') as HTMLElement | null;
    if (!el) {
      el = document.createElement('div');
      el.id = 'ntx-tooltip-root';
      Object.assign(el.style, {
        position: 'fixed',
        inset: '0',
        overflow: 'hidden',
        zIndex: '3000',
        pointerEvents: 'none'
      });
      document.body.appendChild(el);
    }
    tooltipRootRef.current = el;
  }, []);

  const filteredReports = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return ReportsList || [];

    return (ReportsList || []).filter((item: any) => {
      return (
        item?.name?.toLowerCase?.().includes(q) ||
        item?.name2?.toLowerCase?.().includes(q) ||
        item?.moduleName?.toLowerCase?.().includes(q) ||
        item?.moduleName2?.toLowerCase?.().includes(q)
      );
    });
  }, [ReportsList, search]);

  const staticReports = useMemo(() => filteredReports.filter((x: any) => x.type === 'static'), [filteredReports]);
  const customReports = useMemo(() => filteredReports.filter((x: any) => x.type === 'custom'), [filteredReports]);

  const showTabs = reportType === 'both';

  const reportsToShow = useMemo(() => {
    if (!showTabs) {
      return reportType === 'custom-only' ? customReports : staticReports;
    }
    return activeTab === 'static' ? staticReports : customReports;
  }, [activeTab, customReports, reportType, showTabs, staticReports]);

  const tabs = useMemo(() => {
    if (!showTabs) return [];
    return [
      { key: 'static' as const, label: t('Standard'), count: staticReports.length || 0, icon: 'bi bi-check-circle' },
      { key: 'custom' as const, label: t('Custom'), count: customReports.length || 0, icon: 'bi bi-gear' }
    ];
  }, [showTabs, staticReports.length, customReports.length, t]);

  const renderReportNavItem = (r: any) => {
    const reportName = i18n.language === 'en' ? r?.name : r?.name2 || r?.name;
    const icon = r?.icon || (r?.type === 'static' ? 'bi bi-file-earmark-text' : 'bi bi-gear');
    const isActive = report?.id === r.id;
    const isRtl = (document?.documentElement?.dir || i18n.dir?.()) === 'rtl';

    // في وضع الجوال أو الـ Expanded
    if (sidebarExpanded || window.innerWidth < 768) {
      return (
        <Nav.Item key={r.id} className='mb-1 w-100 px-2'>
          <Nav.Link
            active={isActive}
            onClick={() => {
              setReport(r);
              if (window.innerWidth < 768) setShowMobileSidebar(false);
            }}
            className='d-flex align-items-center gap-2 rounded w-100 text-body'
            style={{ minHeight: '44px', transition: 'all 0.2s ease', padding: '10px 10px' }}
          >
            <span
              className='d-flex align-items-center justify-content-center rounded'
              style={{ width: 28, height: 28, flex: '0 0 auto' }}
            >
              <i className={`${icon} ${isActive ? 'text-white' : 'text-theme'}`} style={{ fontSize: '1.15rem' }} />
            </span>
            <span className='text-truncate fw-semibold' style={{ fontSize: '0.9rem', flex: '1 1 auto' }}>
              {reportName}
            </span>
          </Nav.Link>
        </Nav.Item>
      );
    }

    // وضع الـ Collapsed (أيقونات فقط مع Tooltip)
    return (
      <PopoverCustom
        key={r.id}
        placement={isRtl ? 'left' : 'right'}
        Body={<div className='fw-bold'>{reportName}</div>}
        trigger={['hover', 'focus']}
      >
        <Nav.Item className='mb-2'>
          <Nav.Link
            active={isActive}
            onClick={() => setReport(r)}
            className='d-flex align-items-center justify-content-center p-2 rounded'
            style={{ width: '44px', height: '44px' }}
          >
            <i className={`${icon} ${isActive ? 'text-white' : 'text-theme'}`} style={{ fontSize: '1.25rem' }} />
          </Nav.Link>
        </Nav.Item>
      </PopoverCustom>
    );
  };

  const reportTitle = report ? (i18n.language === 'en' ? report?.name : report?.name2 || report?.name) : '';
  const reportDesc =
    report && (i18n.language === 'en' ? report?.description : report?.description2 || report?.description);

  return (
    <>
      <div className='container-fluid p-0' style={{ height: '100%' }}>
        <div className='card border-0 shadow-sm h-100'>
          {/* Header */}
          <div className='card-header bg-theme bg-opacity-10 border-bottom'>
            <div className='d-flex flex-wrap align-items-center justify-content-between gap-2'>
              <div className='d-flex align-items-center gap-2'>
                {/* زر الجوال لفتح السايدبار */}
                <button className='btn btn-theme d-md-none p-1 px-2 me-2' onClick={() => setShowMobileSidebar(true)}>
                  <i className='bi bi-list fs-4' />
                </button>

                <h5 className='mb-0 me-md-4 d-none d-sm-block'>
                  <i className='bi bi-file-earmark-text me-2' />
                  {t('Reports')}
                </h5>

                {showTabs &&
                  tabs.map(m => (
                    <button
                      key={m.key}
                      className={`btn btn-sm ${activeTab === m.key ? 'btn-theme' : 'btn-outline-theme'}`}
                      onClick={() => {
                        setActiveTab(m.key);
                        setReport(null);
                      }}
                    >
                      <i className={`${m.icon} me-1`} />
                      <span className='d-none d-sm-inline'>{m.label}</span>
                    </button>
                  ))}
              </div>

              <div className='d-flex align-items-center gap-2'>
                <button className='btn btn-outline-secondary btn-sm' onClick={() => navigate(-1)}>
                  {t('Back')}
                </button>
              </div>
            </div>
          </div>

          <Loading loading={loading}>
            <div className='card-body p-0 d-flex h-100' style={{ overflow: 'hidden', position: 'relative' }}>
              {/* Overlay للجوال عند فتح السايدبار */}
              {showMobileSidebar && (
                <div className='mobile-sidebar-backdrop d-md-none bg-body' onClick={() => setShowMobileSidebar(false)} />
              )}

              {/* Sidebar */}
              <div
                className={`
                  sidebar-wrapper border-end bg-secondary bg-opacity-10 shadow-sm
                  ${showMobileSidebar ? 'mobile-show ' : 'mobile-hide'}
                `}
                style={{
                  width: sidebarExpanded ? '320px' : '70px',
                  transition: 'all 0.3s ease'
                }}
              >
                {/* رأس السايدبار */}
                <div className='d-flex align-items-center justify-content-between px-2 py-2 border-bottom bg-theme bg-opacity-10'>
                  <div className='d-flex align-items-center gap-2' style={{ minWidth: 0 }}>
                    {(sidebarExpanded || showMobileSidebar) && (
                      <span className='fw-semibold text-theme text-truncate ms-2'>{t('Reports')}</span>
                    )}
                  </div>

                  {/* زر التصغير (يظهر فقط في الشاشات الكبيرة) */}
                  <button
                    className='btn btn-sm btn-outline-theme d-none d-md-block'
                    onClick={() => setSidebarExpanded(v => !v)}
                    title={sidebarExpanded ? t('Collapse') : t('Expand')}
                    style={{ width: 34, height: 34 }}
                  >
                    <i className={`bi ${sidebarExpanded ? 'bi-chevron-bar-right' : 'bi-chevron-bar-left'}`} />
                  </button>

                  {/* زر الإغلاق (يظهر فقط في الجوال) */}
                  <button className='btn-close d-md-none me-2' onClick={() => setShowMobileSidebar(false)}></button>
                </div>

                {/* قائمة التقارير */}
                <div className='flex-grow-1' style={{ overflowY: 'auto' }}>
                  <Nav
                    variant='pills'
                    className={`py-2 d-flex flex-column ${!sidebarExpanded && !showMobileSidebar ? 'align-items-center' : 'align-items-stretch'}`}
                  >
                    {reportsToShow?.length > 0 ? (
                      reportsToShow.map(renderReportNavItem)
                    ) : (
                      <div className='text-center mt-4 text-muted small'>{t('NoReportsFound')}</div>
                    )}
                  </Nav>
                </div>
              </div>

              {/* Main Content */}
              <div className='flex-grow-1 h-100' style={{ overflow: 'auto' }}>
                {!report ? (
                  <div className='h-100 d-flex flex-column align-items-center justify-content-center text-center p-4'>
                    <div className='bg-theme-light bg-opacity-10 rounded-circle p-4 p-md-5 mb-4'>
                      <i className='bi bi-file-earmark-text display-1 text-theme opacity-50' />
                    </div>
                    <h3 className='mb-3 px-2'>{t('WelcomeReportManagerTitle')}</h3>
                    <p className='text-muted mb-0 px-2' style={{ maxWidth: 520 }}>
                      {t('WelcomeReportManagerDescription')}
                    </p>
                  </div>
                ) : (
                  <div className='h-100 d-flex flex-column'>
                    <div className='border-bottom bg-body p-3'>
                      <div className='d-flex align-items-center gap-3'>
                        <div className='bg-theme bg-opacity-10 rounded-2 p-2'>
                          <i className={`${report?.icon || 'bi bi-file-earmark-text'} text-theme fs-4`} />
                        </div>
                        <div style={{ minWidth: 0 }}>
                          <h6 className='mb-0 fw-bold text-truncate'>{reportTitle}</h6>
                          <span
                            className={`badge ${report?.type === 'static' ? 'bg-theme' : 'bg-warning'} bg-opacity-10 ${report?.type === 'static' ? 'text-theme' : 'text-warning'} mt-1`}
                          >
                            {report?.type === 'static' ? t('StandardReport') : t('CustomReport')}
                          </span>
                        </div>
                      </div>

                      {!!reportDesc && (
                        <div className='alert alert-info mt-3 mb-0 py-2'>
                          <i className='bi bi-info-circle me-2' />
                          <small>{reportDesc}</small>
                        </div>
                      )}
                    </div>

                    <div className='flex-grow-1 p-2 p-md-3' style={{ overflowY: 'auto' }}>
                      {report.type === 'static' && report.component ? (
                        <div className='report-preview'>{report.component}</div>
                      ) : (
                        <div className='report-builder'>
                          <ReportsBuilder2 ReportId={report.id} />
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </Loading>
        </div>
      </div>

      <style>{`
        /* تنسيقات السايدبار في الشاشات الكبيرة */
        .sidebar-wrapper {
          z-index: 100;
          background: white;
        }

        /* تنسيقات الجوال */
        @media (max-width: 767.98px) {
          .sidebar-wrapper {
            position: absolute;
            top: 0;
            bottom: 0;
            z-index: 2000;
            width: 280px !important;
          }
          
          .mobile-hide {
            transform: translateX(-100%);
          }
          [dir='rtl'] .mobile-hide {
            transform: translateX(100%);
          }
          
          .mobile-show {
            transform: translateX(0);
          }

          .mobile-sidebar-backdrop {
            position: absolute;
            inset: 0;
            background: rgba(0,0,0,0.4);
            z-index: 1999;
          }
        }

        .nav-pills .nav-link.active {
          background-color: var(--bs-theme);
        }
        
        .nav-pills .nav-link:hover:not(.active) {
          background-color: var(--bs-secondary-bg);
        }
      `}</style>
    </>
  );
};

export default Index2;
